var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36a17.9 17.9 0 0 1-7.007-1.413 17.94 17.94 0 0 1-5.72-3.86 17.94 17.94 0 0 1-3.86-5.72A17.885 17.885 0 0 1 0 18a1.265 1.265 0 1 1 2.531 0 15.445 15.445 0 0 0 4.532 10.94 15.39 15.39 0 0 0 4.918 3.316A15.381 15.381 0 0 0 18 33.469a15.444 15.444 0 0 0 10.94-4.532 15.39 15.39 0 0 0 3.316-4.918A15.381 15.381 0 0 0 33.469 18a15.35 15.35 0 0 0-1.217-6.022 15.484 15.484 0 0 0-3.315-4.919 15.388 15.388 0 0 0-4.918-3.315A15.38 15.38 0 0 0 18 2.531 1.265 1.265 0 1 1 18 0a17.9 17.9 0 0 1 7.007 1.413 17.94 17.94 0 0 1 5.72 3.86 17.968 17.968 0 0 1 3.856 5.72A17.885 17.885 0 0 1 35.996 18c0 2.43-.474 4.788-1.413 7.007a17.873 17.873 0 0 1-3.856 5.72A17.968 17.968 0 0 1 18 36z",
    fill: "#52CA46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loader_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgLoader;